<template>
    <div>
        <v-app>
            <transition mode="out-in">
                <router-view></router-view>
            </transition>
            <v-footer app class="d-flex justify-end caption" style="background-color: #f5f5f5;"><span class="text--disabled">{{ systemVersion }}</span></v-footer>
        </v-app>
    </div>
</template>

<script>
    import { LOAD_SYSTEM_VERSION } from './store/actions/systemInfo'

    export default {
        name: 'App',
        data: () => ({}),
        computed: {
            systemVersion() {
                return this.$store.state.systemInfo.version
            }
        },
        mounted() {
            this.$store.dispatch(LOAD_SYSTEM_VERSION)
        }
    };
</script>
